import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import * as Urql from '@/utils/urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type UpdateGroupMutationVariables = Types.Exact<{
  data: Types.UpdateGroupInput;
}>;


export type UpdateGroupMutation = { updateGroup: { __typename: 'ContentCollectionGroupType', id: string, name: string } | { __typename: 'UserCollectionGroupType' } };


export const UpdateGroupDocument = /*#__PURE__*/ gql`
    mutation updateGroup($data: UpdateGroupInput!) {
  updateGroup(data: $data) {
    __typename
    ... on ContentCollectionGroupType {
      id
      name
    }
  }
}
    `;

export function useUpdateGroupMutation() {
  return Urql.useMutation<UpdateGroupMutation, UpdateGroupMutationVariables>(UpdateGroupDocument);
};